import { isString } from 'lodash';
import { validatePolish } from 'validate-polish';

import { assertUnreachable, Bean, FieldControllerProps, Validate } from '@dreryk/react-common';
import { ClassNameProp, TextInput } from '@dreryk/react-components';

import { healthcareProviderTranslationKeys } from '../../translations';

const REGON_LENGTH = 9;
const UNIT_REGON_LENGTH = 14;

type RegonInputType = 'regon' | 'unit';
type RegonInputProps = FieldControllerProps<'regon', string | null> &
   ClassNameProp & {
      readonly type: RegonInputType;
   };

const getLengthByRegonInputType = (type: RegonInputType): number => {
   switch (type) {
      case 'regon':
         return REGON_LENGTH;
      case 'unit':
         return UNIT_REGON_LENGTH;
      default:
         return assertUnreachable(type);
   }
};

const validateREGON: Validate<Bean> = (data) => {
   if (isString(data) && !validatePolish.regon(data)) {
      return healthcareProviderTranslationKeys.invalidRegon;
   }

   return undefined;
};

export const RegonInput = (props: RegonInputProps): JSX.Element => {
   const length = getLengthByRegonInputType(props.type);
   const controller = props.register(props.name, {
      required: props.required,
      minLength: length,
      maxLength: length,
      validate: validateREGON,
   });

   return (
      <TextInput
         testId={props.name}
         label={healthcareProviderTranslationKeys.regon}
         controller={controller}
         defaultValue={props.defaultValue}
         className={props.className}
      />
   );
};
